/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChannelItemViewModel } from "../types/ChannelItemViewModel.ts";
import { ePlayerTypeSchema } from "./ePlayerTypeSchema.ts";

export const channelItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do canal.")),
  channelCode: z
    .string()
    .describe("Código de incorporação do canal.")
    .nullish(),
  channelName: z.string().describe("Nome do canal.").nullish(),
  videoVimeoId: z
    .string()
    .describe("ID do vídeo no Vimeo. Opcional.")
    .nullish(),
  playerType: z.optional(
    z
      .lazy(() => ePlayerTypeSchema)
      .describe("1 = Vimeo | 2 = YouTube | 3 = JWPlayer | 4 = Others | "),
  ),
  liveStreamLink: z
    .string()
    .describe("Link de transmissão ao vivo. Opcional.")
    .nullish(),
  isAudio: z.optional(z.boolean().describe("Indica se o canal é de áudio.")),
  active: z.optional(z.boolean().describe("Indica se o canal está ativo.")),
}) as unknown as ToZod<ChannelItemViewModel>;
